module.exports = __webpack_public_path__ + "epdf-app/admin/activities/activities-1W85pozp.html";